import { render, staticRenderFns } from "./VistaFacturas.vue?vue&type=template&id=daa75e58"
import script from "./VistaFacturas.vue?vue&type=script&lang=js"
export * from "./VistaFacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports